/**
 * @param {*} filterObject 
 * This filter checks if the object is empty indicating no filters have been
 * applied to the data. Required in the delete multiple functions.
 */
export const emptyFiltersCheck = (filterObject) =>{
    const filterItems = Object.values(filterObject)
    let result = true
    for(let i = 0; i < filterItems.length; i++){
        if (filterItems[i] !== ''){
            result = false
            break
        } 
    }

    return result
}